import React from "react";

import noop from "lodash/noop";
import RequestQuoteFlowSuccess from "pages/shipper/pages/request-quote/components/RequestQuoteFlowSuccess";
import { useTranslation } from "react-i18next";

import { useStepStates } from "../../../../hooks/useStep";
import { useLtlRequestQuoteSelector } from "../../store/ltlState";

const LtlFlowSuccessContainer: React.FC = () => {
  const { t } = useTranslation("shipper");

  const step = useLtlRequestQuoteSelector((state) => state.ltlStepSlice.step);
  const { quoteRequestId } = useStepStates({ onLoading: noop });

  return (
    <RequestQuoteFlowSuccess
      active={step === "success"}
      redirectTo={`/shipper/quotes/${quoteRequestId}`}
      ctaText={t("requestQuoteFlowSuccess.viewQuotes")}
    />
  );
};

export default LtlFlowSuccessContainer;
